module.exports = __webpack_public_path__ + "img/009-university.f499d3e8.png";